import * as Icons from "lucide-react";

export const Icon = ({ name, className = "h-5 w-5" }) => {
  const C = Icons[name] || Icons.Circle;
  return <C className={className} aria-hidden="true" />;
};
